(function (angular) {
    'use strict';

    angular.module('dataPreferences')
        /**
         *
         */
        .controller('dataPreferencesController',
            ['$scope', '$stateParams', 'broadcastChannels', 'inboundRulesData', 'profilesOptIn', 'dataRetention', 'inboundOptOutService', 'inboundOptOut', '$q', 'growlService', 'profilesService', 'dataPreferencesService', 'permissionService', 'portalConfig', 'possibleChannels',
                function ($scope, $stateParams, broadcastChannels, optOutRulesData, profilesOptIn, dataRetention, inboundOptOutService, inboundOptOut, $q, growlService, profilesService, dataPreferencesService, permissionService, portalConfig, possibleChannels) {
                    $scope.defaultRetentions = {
                        profile: portalConfig.defaultProfileRetentionDays,
                        message: portalConfig.defaultMessageRetentionDays
                    };

                    $scope.possibleChannels = possibleChannels.filter((c) => c.allowed);

                    $scope.permissions = {
                        retention: permissionService.checkPermission('apis:ra'),
                        profileOpt: permissionService.checkPermission('apis:ra'),
                        ruleOpt: permissionService.checkPermission('auto:optout:r'),
                    };

                    $scope.messagingRetention = {};
                    $scope.dataRetention = dataRetention;
                    $scope.optOutRules = inboundOptOut || [];
                    $scope.availableChannels = optOutRulesData.data.availableChannels;
                    $scope.profilesOptIn = profilesOptIn;

                    //config
                    $scope.timeSpans = ["Days", "Months"];

                    var actionsConfiguration = [{
                        name: 'Opt-in/Opt-out',
                        id: 'optOutChange',
                        options: [{ name: 'opt', type: 'optEnum' }]
                    }];

                    $scope.settings = {
                        profileSchema: optOutRulesData.data.profileSchema,
                        availableChannels: optOutRulesData.data.availableChannels,
                        channels: broadcastChannels,
                        inboundOptions: {
                            fbPages: [optOutRulesData.data.fbPages],
                            // teams: [{name: "[ANY]", "id": "*"}].concat(optOutRulesData.data.teams),
                            teams: optOutRulesData.data.teams,
                            // prepend in a wildcard option (without modifying source)
                            inboundNumbers: [{ name: "[ANY]", "number": "*" }].concat(optOutRulesData.data.inboundNumbers),
                            email: [optOutRulesData.data.email],
                            whatsApp: optOutRulesData.data.whatsApp,
                            rcs: optOutRulesData.data.rcs
                        },
                        shortCodes: optOutRulesData.data.shortCodes,
                        actionsConfiguration: actionsConfiguration,
                        defaultEmail: optOutRulesData.data.email ? optOutRulesData.data.email.defaultInboundAddress : '',
                        defaultMailboxName: optOutRulesData.data.email ? optOutRulesData.data.email.defaultMailboxName : '',
                        hideSave: true
                    };

                    $scope.addNew = function () {
                        $scope.optOutRules.push({
                            action: "optOutChange",
                            actionData: { opt: "out" }
                        });
                    };

                    $scope.save = function () {
                        var promises = [];
                        if ($scope.permissions.retention) {
                            promises.push(saveDataRetention());
                        }
                        if ($scope.permissions.profileOpt) {
                            promises.push(saveDefaultOptOut());
                        }
                        if ($scope.permissions.ruleOpt) {
                            promises.push(saveOptOuts());
                        }
                        $q.all(promises).then(function () {
                            growlService.success('Data preferences successfully saved');
                        }).catch(function () {

                        });
                    };

                    function saveDataRetention() {
                        return dataPreferencesService.setDataRetention($stateParams.pickedApiSpaceId, $scope.dataRetention).catch(function (error) {
                            growlService.danger("Default opt out config wasn't set due to: " + error.statusText);
                            return $q.reject();
                        });
                    }

                    function saveDefaultOptOut() {
                        return profilesService.setProfilesOptInConfig($stateParams.pickedApiSpaceId, $scope.profilesOptIn).catch(function (error) {
                            growlService.danger("Default opt out config wasn't set due to: " + error.statusText);
                            return $q.reject();
                        });
                    }

                    function saveOptOuts() {
                        var promises = [];
                        for (var index in $scope.optOutRules) {
                            if (!$scope.optOutRules[index].id) {
                                promises.push(inboundOptOutService.createInboundOptOut($stateParams.pickedApiSpaceId, getInboundOptOutData($scope.optOutRules[index])).then(function (data) {
                                    $scope.optOutRules[index].id = data.id;
                                }).catch(function (error) {
                                    growlService.danger("Opt out rule wasn't created due to: " + error.statusText);
                                    return $q.reject();
                                }));
                            }
                            else {
                                promises.push(inboundOptOutService.updateInboundOptOut($stateParams.pickedApiSpaceId, getInboundOptOutData($scope.optOutRules[index])).catch(function (error) {
                                    growlService.danger("Opt out rule wasn't updated due to: " + error.statusText);
                                    return $q.reject();
                                }));
                            }
                        }
                        return $q.all(promises);
                    }


                    $scope.deleteRule = function (index) {
                        if ($scope.optOutRules[index].id) {
                            inboundOptOutService.deleteInboundOptOut($stateParams.pickedApiSpaceId, $scope.optOutRules[index].id).then(function (data) {
                                growlService.success('Opt out rule successfully deleted');
                                $scope.optOutRules.splice(index, 1);
                            }).catch(function (error) {
                                growlService.danger("Opt out rule wasn't deleted due to: " + error.statusText);
                            });
                        }
                        else {
                            $scope.optOutRules.splice(index, 1);
                        }
                    };

                    function getInboundOptOutData(data) {
                        var optOutRule = {};
                        if (data.id) {
                            optOutRule.id = data.id;
                        }
                        if (data.channel) {
                            optOutRule.channel = data.channel;
                        }
                        if (data.channel && data.inbound) {
                            optOutRule.inbound = data.inbound;
                        }
                        if (data.keyword) {
                            optOutRule.keyword = data.keyword;
                        }
                        if (data.action) {
                            optOutRule.action = data.action;
                        }
                        if (data.action && data.actionData) {
                            optOutRule.actionData = {};
                            optOutRule.actionData.opt = data.actionData.opt;
                        }

                        return optOutRule;
                    }
                }]);




})(window.angular);
